import React, { createContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import 'aos/dist/aos.css'; // AOS 스타일 파일을 임포트
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import 'swiper/css/grid';
import './assets/scss/globalComponent.scss';
import './assets/scss/main.scss';
import RoutePage from './RoutePage';
import { useLocation } from 'react-router-dom';
import Header from './components/global/Header';
import Modal from './components/global/Modal';
import { useModal } from './context/ModalContext';
import Footer from './components/global/Footer';

export const HeaderHeightContext = createContext(null); // ⬅️ Context를 export 해줘야 함
function App() {
  const [isHeaderChange, setIsHeaderChange] = useState(false);
  const location = useLocation();
  const mainFirstSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!mainFirstSectionRef.current) return;

      const scrollY = window.scrollY + window.innerHeight / 2;
      const locationPath = location.pathname;

      const heroBottom =
        locationPath === '/privacy' || locationPath === '/servicepolicy'
          ? 0
          : mainFirstSectionRef.current.offsetTop +
          mainFirstSectionRef.current.offsetHeight;

      setIsHeaderChange(scrollY > heroBottom);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // 초기값 반영

    return () => window.removeEventListener('scroll', handleScroll);
  }, [location]); // location이 바뀔 때도 다시 실행되도록 의존성 추가
  const headerRef = useRef(null);
  useEffect(() => {
    let resizeTimer: number;

    const handleResize = () => {
      document.documentElement.classList.add("resizing");

      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        document.documentElement.classList.remove("resizing");
      }, 200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const { isModalOpen, setIsModalOpen } = useModal();
  const [headerHeight, setHeaderHeight] = useState(null);
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    if (headerRef.current) {
      setTimeout(() => {
        setHeaderHeight(headerRef.current.getBoundingClientRect().height);
      }, 0);
    }
  }, [location.pathname]); // ✅ 경로가 변경될 때마다 실행
  // 💡 상태 변경 확인용 로그
  useEffect(() => {
    console.log('Updated headerHeight:', headerHeight);
  }, [headerHeight]); // ✅ headerHeight가 변경될 때 실행
  return (
      <HeaderHeightContext.Provider value={headerHeight}>
      <div className={`App `}>
        <Header headerRef={headerRef} isHeaderChange={isHeaderChange} />
        <RoutePage mainFirstSectionRef={mainFirstSectionRef} />
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        <Footer/>
      </div>
      </HeaderHeightContext.Provider>
  );
}

export default App;
